import { reactive } from 'vue'

const THEME_KEY = 'rdo_theme'

function applyTheme(dark: boolean) {
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
}

const state = reactive({
  darkMode: localStorage.getItem(THEME_KEY) === 'dark'
})

export const themeStore = {
  state,
  get isDark() {
    return state.darkMode
  },
  init() {
    applyTheme(state.darkMode)
  },
  toggle() {
    state.darkMode = !state.darkMode
    localStorage.setItem(THEME_KEY, state.darkMode ? 'dark' : 'light')
    applyTheme(state.darkMode)
  },
  setDark(dark: boolean) {
    state.darkMode = dark
    localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light')
    applyTheme(dark)
  }
}
